// components/Spinner/Spinner.tsx

import styles from "./Spinner.module.css";

export default function Spinner() {
  return (
    <div className={styles.overlay}>
      <div className={styles.loader}>
        <div className={styles.ring}></div>
        <div className={styles.ring}></div>

        <div className={styles.iconWrapper}>
          <svg
            className={styles.icon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="6" />

            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M20 20l-4.2-4.2"
            />
          </svg>
        </div>
      </div>

      <div className={styles.text}>
        <h2>Daten werden geladen</h2>
        <p>Bitte warten Sie einen Moment...</p>
      </div>
    </div>
  );
}